import { InjectionKey, Ref } from 'vue'

export const mapSymbol: InjectionKey<Ref<google.maps.Map | undefined>> =
  Symbol('map')
export const apiSymbol: InjectionKey<Ref<typeof google.maps | undefined>> =
  Symbol('api')
